import React, { useContext } from 'react'
import { TranslateContext } from 'client/common/translator'
import { Text } from 'chemistry'

const ZeroResults = ({ searchQuery = ' ' }) => {
  const t = useContext(TranslateContext)

  return (
    <div className='flex items-center gap-1 flex-column my4'>
      <img src='https://d3ufyq13vbk1ak.cloudfront.net/images/0_results.svg' alt='zero results' />
      <Text fontSize='4xl' fontFamily='bold'>
        {`${t('lister.search.zeroResults')} '${searchQuery}'`}
      </Text>
      <Text fontSize='md'>{t('lister.search.zeroResultsSuggestion')}</Text>
    </div>
  )
}

export default ZeroResults
